export enum CardDataType {
    OnDemand = 0,
    Channel = 1,
    Guide = 2,
    Credit = 3,
    ShowAll = 100,
    Plus = 101,
    TabsGenres = 102,
    FiltersVod = 103,
}
